import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Divider, Link, Stack, Typography } from "@mui/material";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import SpaRoundedIcon from "@mui/icons-material/SpaRounded";
import { clinic } from "../constants/clinic";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: "#E8F0E8",
      color: "text.primary",
      borderTop: "1px solid #D6D3D1",
      pb: { xs: 11, md: 0 },
    }}
  >
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.3fr 1fr 0.8fr" },
          gap: { xs: 4.5, md: 8 },
        }}
      >
        <Box>
          <Stack direction="row" alignItems="center" spacing={1.25} sx={{ mb: 2 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                display: "grid",
                placeItems: "center",
                bgcolor: "rgba(255,255,255,.52)",
                color: "primary.dark",
                borderRadius: "50% 50% 50% 14px",
              }}
            >
              <SpaRoundedIcon />
            </Box>
            <Typography
              variant="h5"
              sx={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: ".08em" }}
            >
              わかば接骨院
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: "rgba(41,37,36,.76)", mb: 2.5 }}>
            瀬戸市共栄通で、一人ひとりの体と丁寧に向き合う接骨院です。
            腰の痛み・肩の痛み、運動療法についてお気軽にご相談ください。
          </Typography>
          <Button
            component="a"
            href={clinic.phoneHref}
            color="primary"
            variant="contained"
            startIcon={<LocalPhoneRoundedIcon />}
          >
            {clinic.phone}
          </Button>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ mb: 1.5 }}>診療時間</Typography>
          <Typography variant="body2" sx={{ color: "rgba(41,37,36,.78)" }}>
            月・火・木・金<br />
            午前9時から12時 / 午後4時から8時<br />
            水・土　午前9時から12時<br />
            日曜・祝日　休診
          </Typography>
          <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>所在地</Typography>
          <Typography variant="body2" sx={{ color: "rgba(41,37,36,.78)" }}>
            〒{clinic.postalCode}<br />
            {clinic.address}<br />
            {clinic.station}
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ mb: 1.25 }}>ご案内</Typography>
          <Stack spacing={1.1} alignItems="flex-start">
            {[
              ["当院について", "/about"],
              ["施術内容", "/services"],
              ["アクセス", "/access"],
              ["ご予約・お問い合わせ", "/contact"],
              ["サイトマップ", "/sitemap"],
            ].map(([label, path]) => (
              <Link key={path} component={RouterLink} to={path} color="inherit" underline="hover">
                {label}
              </Link>
            ))}
          </Stack>
        </Box>
      </Box>

      <Divider sx={{ my: 4, borderColor: "rgba(41,37,36,.16)" }} />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <Typography variant="caption" sx={{ color: "rgba(41,37,36,.64)" }}>
          © {new Date().getFullYear()} わかば接骨院
        </Typography>
        <Stack direction="row" spacing={2}>
          <Link component={RouterLink} to="/privacy-policy" color="inherit" variant="caption">
            プライバシーポリシー
          </Link>
          <Link component={RouterLink} to="/terms-of-service" color="inherit" variant="caption">
            利用規約
          </Link>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
